import { render, staticRenderFns } from "./mobileTest.vue?vue&type=template&id=fea285f8&scoped=true&"
import script from "./mobileTest.vue?vue&type=script&lang=js&"
export * from "./mobileTest.vue?vue&type=script&lang=js&"
import style0 from "./mobileTest.vue?vue&type=style&index=0&id=fea285f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea285f8",
  null
  
)

export default component.exports